var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MUIRadioGroup from '@mui/material/RadioGroup';
import Grid from '@mui/material/Grid';
import RadioOption from './RadioOption';
function RadioGroup(_a) {
    var name = _a.name, id = _a.id, selectedValue = _a.value, onChange = _a.onChange, _b = _a.options, options = _b === void 0 ? [] : _b, error = _a.error, disabled = _a.disabled, colProps = _a.colProps;
    return (React.createElement(MUIRadioGroup, { name: name, id: id || name, value: String(selectedValue) },
        React.createElement(Grid, { container: true, spacing: 1 }, options === null || options === void 0 ? void 0 : options.map(function (_a) {
            var label = _a.label, value = _a.value, description = _a.description;
            return (React.createElement(Grid, __assign({ key: String(value), item: true }, colProps),
                React.createElement(RadioOption, { label: label, value: value, onSelect: onChange, description: description, error: !!error, disabled: !!disabled, isSelected: selectedValue === value })));
        }))));
}
RadioGroup.defaultProps = {
    colProps: {
        xs: 12,
        sm: 6,
        md: 4,
    },
};
export default RadioGroup;
